import React from 'react'
import AgreedConsumptionDTO from 'features/contracts/dtos/AgreedConsumptionDTO';
import PriceDTO from 'features/contracts/dtos/PriceDTO';
import ContractAgreedConsumptionsCard from './ContractAgreedConsumptionsCard';
import ContractPricesCard from './ContractPricesCard';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import styles from './contractAdditionalInfoList.module.scss';

type Props = {
  prices: PriceDTO[];
  consumptions: AgreedConsumptionDTO[];
}

const ContractAdditionalInfoList = ({ prices, consumptions }: Props) => {
  // helpers
  const isVisibleComponents = (): boolean => { 
    if ((prices && prices.length > 0) || consumptions) {
      return true;
    }

    return false;
  }

  const isVisiblePrices = (): boolean => { 
    if (prices && prices.length > 0) {
      return true;
    }

    return false;
  }

  const isVisibleConsumptions = (): boolean => { 
    if (consumptions) {
      return true;
    }

    return false;
  }

  // render
  return (
    <RenderWrapper isVisible={isVisibleComponents}>
      <div className="row no-gutters mx-n2">
        <RenderWrapper isVisible={isVisibleConsumptions}>
          <div className="col-sm px-2">
            <ContractAgreedConsumptionsCard 
              consuptions={consumptions} 
              className={styles.card}
            />
          </div>
        </RenderWrapper>
        <RenderWrapper isVisible={isVisiblePrices}>
          <div className="col-sm px-2">
            <ContractPricesCard 
              prices={prices}
              className={styles.card}
            />
          </div>
        </RenderWrapper>
      </div>
    </RenderWrapper>
  )
}

export default ContractAdditionalInfoList